const myOrderList = []

export default {
  myOrderList
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-extended-insurance/store/state.js